import React, {Component} from 'react';
import {Dropdown, Button} from 'semantic-ui-react';

import Alert from "../../components/extras/Alert";
import SaleData from "../../data/SaleData";

const all_options = [
    {key: 0, icon: 'shopping cart', text: 'Sin asignar ', value: 0, color: 'gray'},
    {key: 1, icon: 'shopping cart', text: 'En solicitud ', value: 1, color: 'teal'},
    {key: 2, icon: 'food', text: 'En preparación ', value: 2, color: 'blue'},
    {key: 3, icon: 'bicycle', text: 'En camino ', value: 3, color: 'yellow'},
    {key: 4, icon: 'smile', text: 'Entregado ', value: 4, color: 'olive'},
    {key: 5, icon: 'remove', text: 'Anulado ', value: 5, color: 'orange'},
    {key: 6, icon: 'map signs', text: 'Dirección no encontada ', value: 6, color: 'orange'},
    {key: 7, icon: 'remove user', text: 'El cliente rechazó el domicilio ', value: 7, color: 'orange'},
    {key: 8, icon: 'food', text: 'Preparado ', value: 8, color: 'blue'},
];

const options = [
    {key: 3, icon: 'bicycle', text: 'En camino ', value: 3, color: 'yellow'},
    {key: 4, icon: 'smile', text: 'Entregado ', value: 4, color: 'olive'},
    {key: 6, icon: 'map signs', text: 'Dirección no encontada ', value: 6, color: 'orange'},
    {key: 7, icon: 'remove user', text: 'El cliente rechazó el domicilio ', value: 7, color: 'orange'},
];

class DeliveryState extends Component {
    constructor(props) {
        super(props);
        this.state = {
            delivery_state: props.state,
            id: props.id,
            loading: false,
            all_options: props.all_options
        };

        this.handleStateChange = this.handleStateChange.bind(this);
    }

    handleStateChange = (delivery_state) => {
        this.updateState(delivery_state);
    };

    async updateState(delivery_state){
        this.setState({loading:true});
        SaleData.deliveryUpdate({id:this.state.id, delivery_state:delivery_state}, 'state', (res) => {
            if(res && res.update){
                this.setState({delivery_state});
            }else {
                this.refs.alert.open({message:'Tenemos un problema!', type:'error'});
            }
            this.setState({loading:false});
        });
    }

    render() {
        return (
            <div>
                <Button.Group fluid color={this.state.all_options ? all_options.find((option) => option.key === this.state.delivery_state).color:options.find((option) => option.key === this.state.delivery_state).color}>
                <Dropdown
                    options={this.state.all_options ? all_options : options}
                    floating
                    fluid
                    loading={this.state.loading}
                    button
                    labeled
                    icon={this.state.delivery_state === 1 ? 'shopping cart' : this.state.delivery_state === 2 ?
                        'food' : this.state.delivery_state === 3 ? 'bicycle' : 'smile'}
                    className='icon'
                    value={this.state.delivery_state}
                    onChange={(e, { value }) => this.handleStateChange(value)}
                />
            </Button.Group>
            <Alert ref='alert' />
        </div>
        );
    }
}

export default DeliveryState;



// WEBPACK FOOTER //
// ./src/components/sale/DeliveryState.js